module.exports = __webpack_public_path__ + "static/media/LINK-QUICK.f5fc88a9.png";